import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExamSummary } from '../models';
import { Api, Session } from '../services/index';


@Component({
  selector: 'app-bh-screen',
  templateUrl: './dashboard-bh-screen.html'
})

export class DashboardBHScreenComponent implements OnInit {

  loading = false;

  constructor(private api: Api, 
              private route: ActivatedRoute,
              private router: Router,
              public session: Session) { 
  }
  
  ngOnInit() {
    this.loading = true;
 
  }
  
  requestExam(){
    this.session.intakeLob = 'PAS';
    this.router.navigate(['/exam-request-care-today' ]);
  }
  
}
